import React from 'react';

interface ICartFieldWrp {
  title?: string;
  children: JSX.Element;
  error?: any;
}

export function CartFieldWrp({ title, children, error }: ICartFieldWrp) {
  return (
    <div className="mb-6 w-full">
      {title && (
        <div className="flex justify-between items-center mb-2.5">
          <span className="text-sm font-medium text-gray-600">{title}</span>
          {error && (
            <span className="text-sm font-medium text-red-600">{error}</span>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
